export function traverse<T>(obj: T, visit: (key: any, value: any, obj: any) => void) {
    for (const key in obj) {
        const value = obj[key]
        visit(key, value, obj)
        if (value !== null && typeof value == 'object') {
            traverse(value, visit)
        }
    }
}
